import { registerJSONResolver } from '../../registry/jsonResolvers';
import { registerComponent, createComponentFromJSON, } from '../../components/registry';
export var uiPlugin = {
    name: 'lightdraw-ui',
    version: '1.2.1',
    install: function (LD) {
        registerJSONResolver(function (type, props, app) { return createComponentFromJSON(type, props, app); });
        LD.registerComponent =
            registerComponent;
    },
};
export { registerComponent, createComponentFromJSON };
export { applyUiTheme, resolveUiTheme, UI_PRESETS, UI_THEME_VAR_MAP } from '../../components/uiTheme';
export { resolveUiCanvasTheme, getCanvasUiTheme, getActiveUi, refreshCanvasUi, syncActiveCanvasUiTheme, runWithCanvasUiTheme, } from '../../components/resolveCanvasTheme';
export { resolveEffectiveUiTokens, resolveNodeTypography, flatTypographyFromProps, hasCustomTextColor, hasCustomFontSize, readNodeUiThemeProp, normalizeNodeUiTheme, hasNodeUiThemeOverride, } from '../../components/nodeTheme';
export default uiPlugin;
